import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface SvgProps extends SvgIconProps {
  disabled?: boolean;
}
export const DefaultIcon = (props: SvgProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 14.5V6.5C2.5 4.567 4.067 3 6 3H14C15.933 3 17.5 4.567 17.5 6.5V14.5C17.5 16.433 15.933 18 14 18H6C4.067 18 2.5 16.433 2.5 14.5Z"
          fill={props.disabled ? "#E1E4E6" : "white"}
          stroke={props.disabled ? "#E1E4E6" : "#B0B9BD"}
        />
      </svg>
    </SvgIcon>
  );
};

export const IndeterminateIcon = (props: SvgProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 2C3.79086 2 2 3.79086 2 6V14C2 16.2091 3.79086 18 6 18H14C16.2091 18 18 16.2091 18 14V6C18 3.79086 16.2091 2 14 2H6Z"
          fill={props.disabled ? "#E8F7FE" : "#0095D5"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13 9H7C6.45 9 6 9.45 6 10C6 10.55 6.45 11 7 11H13C13.55 11 14 10.55 14 10C14 9.45 13.55 9 13 9V9Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export const CheckedIcon = (props: SvgProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 2C3.79086 2 2 3.79086 2 6V14C2 16.2091 3.79086 18 6 18H14C16.2091 18 18 16.2091 18 14V6C18 3.79086 16.2091 2 14 2H6Z"
          fill={props.disabled ? "#E8F7FE" : "#0095D5"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 10.5C6.55228 10.5 7 10.0523 7 9.5C7 8.94772 6.55228 8.5 6 8.5C5.44772 8.5 5 8.94772 5 9.5C5 10.0523 5.44772 10.5 6 10.5Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9 13.5C9.55228 13.5 10 13.0523 10 12.5C10 11.9477 9.55228 11.5 9 11.5C8.44772 11.5 8 11.9477 8 12.5C8 13.0523 8.44772 13.5 9 13.5Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 8.5C14.5523 8.5 15 8.05228 15 7.5C15 6.94772 14.5523 6.5 14 6.5C13.4477 6.5 13 6.94772 13 7.5C13 8.05228 13.4477 8.5 14 8.5Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.29291 13.2071L9.70712 11.7929L6.70712 8.79291L5.29291 10.2071L8.29291 13.2071Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7071 8.20712L13.2929 6.79291L8.29291 11.7929L9.70712 13.2071L14.7071 8.20712Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};
